import Hero from '../components/Hero';
import React,{useState,useEffect} from 'react';
import Services from '../Pages/Services';
import Portfolio from '../Pages/Portfolio';
import Testimonials from '../Pages/Testimonials';
import './Home.css';
import { motion } from 'framer-motion';
import CTA from './CTA';
import Corousel from '../Corousel';
import Footer from './Footer';
import AIAssistant from '../components/AIAssistant';
import Clients from "./Clients"
import Videos from './Videos';
import VideoSection from './VideoSection';
import QuoteForm from '../components/QuoteForm';
import { FaWhatsapp, FaPlus } from 'react-icons/fa';


const Home = () => {
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);


  useEffect(() => {
    const timer = setTimeout(() => {
      setIsQuoteOpen(true);
    }, 20000); // 30,000 ms = 30 seconds

    // Optional cleanup in case the component unmounts
    return () => clearTimeout(timer);
  }, []);

      //handle whatsapp button click 
      const handleWhatsAppClick = () => {
        const phoneNumber = '256709728710'; // replace with your phone number
        const message = 'Hello Kajja Galleries, I have an inquiry.'; // replace with your default message
        window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
      };

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Hero Section */}
      <Corousel/>
      {/* Services Section */}
      <Services />
      <Hero />
      {/* Portfolio Section */}
      <Portfolio />
      <Clients/>
      <Testimonials/>
      
      <Videos/>
      <VideoSection/>
       <div style={{ position: 'fixed', bottom: '30px', right: '30px', zIndex: 1000 }}>
            <button className="floating-button" onClick={handleWhatsAppClick}>
                <FaWhatsapp style={{ fontSize: 30, color: 'white' }} />
            </button>
      </div>
      {/* <AIAssistant/> */}
      {/* <CTA/> */}
      {/* <QuoteForm
        isOpen={isQuoteOpen}
        title="Let’s Design Your Perfect Space Together"
        subtitle="Share a few details and our design team will get in touch with ideas tailored just for you."
        onClose={() => setIsQuoteOpen(false)}
      />   */}
      </motion.main>
  );
};

export default Home;